


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { deepRegion } from '@/utils/common';
import { AppModule } from '@/store/modules/app';
@Component({
	components: {},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	private showPicker: any = false; // 展示隐藏
	private popupValue: number[] = [];
	private changeStatus() {
		this.showPicker = false;
	}
	// 确定
	private comfirm(val) {
		if (this.item.regionType === 1) {
			// 只有省的时候
			this.popupValue = [val.text];
			this.form.filterValue = [val.text];
		} else {
			this.popupValue = val.filter((one) => one);
			this.form.filterValue = val.filter((one) => one);
		}
		// this.popupValue = val;
		// this.form.filterValue = val.join('/');
		this.showPicker = false;
		this.$emit('change');
	}
	// 清空选项
	private clear() {
		this.popupValue = [];
	}
	// 打开抽屉
	private show() {
		this.showPicker = true;
	}
	private get options() {
		return deepRegion(this.$store.state.app.region, 1, this.item.regionType);
	}
	private cancel() {
		this.showPicker = false;
		this.popupValue = [];
		this.form.filterValue = '';
		this.$emit('change');
	}
	get current() {
		return this.popupValue.join('/');
	}
	private mounted() {
		AppModule.getRegionAll();
		this.popupValue = [];
	}
	@Watch('$route.params.viewId')
	private ChildChanged() {
		this.popupValue = [];
	}
}
